module.exports = __webpack_public_path__ + "static/media/687.82af5381.webp";